/** Fisher-Yates Shuffle, in-place
 * Be careful when using this function! Math.random() can cause SSR errors.
 * useLazySSR can help with this.
 * @param {Array} array
 */
export function shuffle(array) {
  let currentIndex = array.length;
  let randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // eslint-disable-next-line no-param-reassign
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

/** Get a random entry of an array.
 * Be careful when using this function! Math.random() can cause SSR errors.
 * useLazySSR can help with this.
 * @param {Array} array
 */
export function getRandomEntry(array) {
  if (!array || !Array.isArray(array) || array.length === 0) {
    return undefined;
  }
  return array[Math.floor(Math.random() * array.length)];
}

export function pickPlural(number, singular, plural) {
  return number !== 1 ? plural : singular;
}
